import AiBotAnswersAPI from 'dashboard/api/aiBot/answers';
import { throwErrorMessage } from '../../utils/api';

const types = {
  SET_UI_FLAG: 'SET_UI_FLAG',
  SET_ANSWERS: 'SET_ANSWERS',
};

export const state = {
  records: [],
  meta: {},
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getRecords: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
  getMeta: $state => $state.meta,
};

export const actions = {
  get: async ({ commit }, { botId, matchType, page, q } = {}) => {
    commit(types.SET_UI_FLAG, { isFetching: true });
    try {
      const response = await new AiBotAnswersAPI(botId).get({
        matchType,
        page,
        q,
      });
      commit(types.SET_ANSWERS, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_UI_FLAG, { isFetching: false });
    }
  },

  create: async (_, { botId, ...answerParams }) => {
    try {
      const response = await new AiBotAnswersAPI(botId).create(answerParams);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    }
  },

  update: async (_, { botId, answerId, ...answerParams }) => {
    try {
      const response = await new AiBotAnswersAPI(botId).update(
        answerId,
        answerParams
      );
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    }
  },

  delete: async (_, { botId, answerId }) => {
    try {
      await new AiBotAnswersAPI(botId).delete(answerId);
      return true;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    }
  },

  import: async (_, { botId, file }) => {
    try {
      const response = await new AiBotAnswersAPI(botId).import(file);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    }
  },
};

export const mutations = {
  [types.SET_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_ANSWERS]($state, records) {
    $state.records = records;
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
